import React from "react";
import { GoogleMap, LoadScript ,useLoadScript,Marker} from "@react-google-maps/api";
const GoogleMapRoute = ({bookingObj}) => {
  const containerStyle = {
    height: '100%',
    width:'100%'
  };
  
  const center = {
    lat: 13.12,
    lng: 77.5848,
  };

  const {isLoaded} = useLoadScript({
    googleMapsApiKey:process.env.REACT_APP_GOOGLE_API_KEY
  })
  if(!isLoaded) return <div>Loading...</div>
  return (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
        
      >
         <Marker

      position={{ lat: bookingObj.pickUpLat, lng: bookingObj.pickUpLng }}
      key={'marker1'}
    />
    <Marker
      position={{ lat: bookingObj.destLat, lng:bookingObj.destLng }}
      key={'marker2'}
    />
      </GoogleMap>
  );
};

export default GoogleMapRoute;
